import React from 'react';
import { Field } from '@base-ui/react';
import { cn } from '../utils';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ElementType;
  rightElement?: React.ReactNode;
  containerClassName?: string;
  label?: string;
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, containerClassName, icon: Icon, rightElement, label, error, required, ...props }, ref) => {
    return (
      <Field.Root className={cn("w-full flex flex-col gap-2", containerClassName)}>
        {label && (
          <Field.Label className="block text-xs font-bold text-zinc-900 uppercase tracking-wide pl-1">
            {label}{required && <span className="ml-0.5 text-red-400">*</span>}
          </Field.Label>
        )}
        <div className="relative w-full">
          {Icon && (
            <Icon
              className="absolute left-4 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none"
              size={18}
            />
          )}
          <Field.Control
            render={<input ref={ref} />}
            required={required}
            className={cn(
              "w-full bg-zinc-50 border-none rounded-2xl text-sm text-zinc-900 placeholder-zinc-400 transition-all py-3.5 pr-4",
              "focus:outline-none focus:ring-2",
              error ? "focus:ring-red-500/50 ring-2 ring-red-200" : "focus:ring-primary/50",
              Icon ? "pl-11" : "pl-4",
              rightElement ? "pr-11" : "pr-4",
              className
            )}
            {...props}
          />
          {rightElement && (
            <div className="absolute right-4 top-1/2 -translate-y-1/2 flex items-center text-zinc-400">
              {rightElement}
            </div>
          )}
        </div>
        {error && (
          <p className="text-xs font-medium text-red-600 pl-1">{error}</p>
        )}
      </Field.Root>
    );
  }
);
Input.displayName = "Input";
